/* src/modules/dashboard/actions.js */

import {
  fetchDashboardLessonsTypes,
  fetchDashboardUsersTypes,
  fetchDashboardStudentsTypes,
  fetchDashboardTutorsTypes,
  fetchPopularCoursesTypes,
  CHANGE_NUMBER_OF_LESSONS_TIME_FRAME,
  CHANGE_NUMBER_OF_LESSONS_TYPE,
  CHANGE_NUMBER_OF_LESSONS_START_DATE,
  CHANGE_NUMBER_OF_LESSONS_END_DATE,
  CHANGE_NUMBER_OF_USERS_TIME_FRAME,
  CHANGE_NUMBER_OF_USERS_TYPE,
  CHANGE_NUMBER_OF_USERS_START_DATE,
  CHANGE_NUMBER_OF_USERS_END_DATE,
  CHANGE_REVENUE_TIME_FRAME,
  CHANGE_REVENUE_TYPE,
  CHANGE_REVENUE_START_DATE,
  CHANGE_REVENUE_END_DATE,
  CHANGE_PROFIT_TIME_FRAME,
  CHANGE_PROFIT_TYPE,
  CHANGE_PROFIT_START_DATE,
  CHANGE_PROFIT_END_DATE,
} from './action_types';

import {
  FETCH_DASHBOARD_LESSONS_QUERY,
  FETCH_DASHBOARD_USERS_QUERY,
  FETCH_DASHBOARD_STUDENTS_QUERY,
  FETCH_DASHBOARD_TUTORS_QUERY,
  FETCH_POPULAR_COURSES_QUERY,
} from './api';
import { makeQuery } from '../../config/client';

export const fetchDashboardLessons = variables => makeQuery(variables)(
  fetchDashboardLessonsTypes,
  FETCH_DASHBOARD_LESSONS_QUERY
);

export const fetchDashboardUsers = variables => makeQuery(variables)(
  fetchDashboardUsersTypes,
  FETCH_DASHBOARD_USERS_QUERY
);

export const fetchDashboardStudents = variables => makeQuery(variables)(
  fetchDashboardStudentsTypes,
  FETCH_DASHBOARD_STUDENTS_QUERY
);

export const fetchDashboardTutors = variables => makeQuery(variables)(
  fetchDashboardTutorsTypes,
  FETCH_DASHBOARD_TUTORS_QUERY
);

export const fetchPopularCourses = variables => makeQuery(variables)(
  fetchPopularCoursesTypes,
  FETCH_POPULAR_COURSES_QUERY
);

export const changeNumberOfLessonsTimeFrame = payload => ({
  type: CHANGE_NUMBER_OF_LESSONS_TIME_FRAME,
  payload,
});

export const changeNumberOfLessonsType = payload => ({
  type: CHANGE_NUMBER_OF_LESSONS_TYPE,
  payload,
});

export const changeNumberOfLessonsStartDate = payload => ({
  type: CHANGE_NUMBER_OF_LESSONS_START_DATE,
  payload,
});

export const changeNumberOfLessonsEndDate = payload => ({
  type: CHANGE_NUMBER_OF_LESSONS_END_DATE,
  payload,
});

export const changeNumberOfUsersTimeFrame = payload => ({
  type: CHANGE_NUMBER_OF_USERS_TIME_FRAME,
  payload,
});

export const changeNumberOfUsersType = payload => ({
  type: CHANGE_NUMBER_OF_USERS_TYPE,
  payload,
});

export const changeNumberOfUsersStartDate = payload => ({
  type: CHANGE_NUMBER_OF_USERS_START_DATE,
  payload,
});

export const changeNumberOfUsersEndDate = payload => ({
  type: CHANGE_NUMBER_OF_USERS_END_DATE,
  payload,
});

export const changeRevenueTimeFrame = payload => ({
  type: CHANGE_REVENUE_TIME_FRAME,
  payload,
});

export const changeRevenueType = payload => ({
  type: CHANGE_REVENUE_TYPE,
  payload,
});

export const changeRevenueStartDate = payload => ({
  type: CHANGE_REVENUE_START_DATE,
  payload,
});

export const changeRevenueEndDate = payload => ({
  type: CHANGE_REVENUE_END_DATE,
  payload,
});

export const changeProfitTimeFrame = payload => ({
  type: CHANGE_PROFIT_TIME_FRAME,
  payload,
});

export const changeProfitType = payload => ({
  type: CHANGE_PROFIT_TYPE,
  payload,
});

export const changeProfitStartDate = payload => ({
  type: CHANGE_PROFIT_START_DATE,
  payload,
});

export const changeProfitEndDate = payload => ({
  type: CHANGE_PROFIT_END_DATE,
  payload,
});



// WEBPACK FOOTER //
// ./src/modules/dashboard/actions.js